import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import withWidth from '@material-ui/core/withWidth';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import Tooltip from '@material-ui/core/Tooltip';

export class OnCallScheduleItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeSlot: this.props.timeSlot, // each time slot looks like: {beginTime, endTime, id, prime, scheduleId, secondary, tertiary}
      beginTime: this.props.timeSlot.beginTime.split("T").pop(), // grabs the time after "T"
      endTime: this.props.timeSlot.endTime.split("T").pop(),
      id: this.props.timeSlot.id,
      scheduleId: this.props.timeSlot.scheduleId,
      prime: this.getNameFromId(this.props.timeSlot.prime, this.props.memberIdMap),
      secondary: this.getNameFromId(this.props.timeSlot.secondary, this.props.memberIdMap),
      tertiary: this.getNameFromId(this.props.timeSlot.tertiary, this.props.memberIdMap),
      memberIdMap: this.props.memberIdMap,
      memberNameMap: this.props.memberNameMap,
      members: this.props.members,
      showDeleteButton: false,
    };
  }

  handleChange = name => (event, val) => {
    var newScheduleOnCallLineItem = {};
    this.setState({ [name]: event.target.value }, () => {
      console.log("[name]: ", name);
      console.log("val: ", val);
      console.log("event.target.value: ", event.target.value);
      
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var datePrefix = yyyy + "-" + mm + "-" + dd + "T";

      // [{beginTime, endTime, id, scheduleId, prime, secondary, tertiary}]
      newScheduleOnCallLineItem.beginTime = datePrefix + this.state.beginTime;
      newScheduleOnCallLineItem.endTime = datePrefix + this.state.endTime;
      newScheduleOnCallLineItem.id = this.state.id;
      newScheduleOnCallLineItem.scheduleId = this.state.scheduleId;
      newScheduleOnCallLineItem.prime = this.getIdFromName(this.state.prime, this.state.memberNameMap)['id'];
      newScheduleOnCallLineItem.secondary = this.getIdFromName(this.state.secondary, this.state.memberNameMap)['id'];
      newScheduleOnCallLineItem.tertiary = this.getIdFromName(this.state.tertiary, this.state.memberNameMap)['id'];
      this.props.callbackFromParent(newScheduleOnCallLineItem);
    });
  };

  handleTimeChange = (name, event) => {
    event.persist();
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    var datePrefix = yyyy + "-" + mm + "-" + dd + "T";
    this.props.callbackFromParent({ 'time_change': true, 'id': this.state.id, 'target': name, 'date': datePrefix + event.target.value });
  };

  getNameFromMember = (member) => {
    if (member === "") {
      return "";
    }
    //return member['firstName'] + " " + member['lastName'];
    return member['firstName'];
  };

  getIdFromName = (name, memberNameToId) => {
    if (name === "") {
      return "";
    }
    return memberNameToId[name];
  };

  getNameFromId = (id, memberIdMap) => {
    if (id === "") {
      return "";
    }
    var member = memberIdMap[id];
    return this.getNameFromMember(member);
  };

  getSalesPeople = members => {
    var listOfSales = [];
    for (var i = 0; i < members.length; i++) {
      var member = members[i];
      if (member['roles'] !== null && member['roles'].includes("S")) {
        listOfSales.push(this.getNameFromMember(member));
      }
    }
    return listOfSales;
  };

  removeRow = () => {
    this.props.callbackFromParent({ 'delete': true, 'id': this.state.id });
  };

  render() {
    let salesMembers = this.getSalesPeople(this.props.members);
    let responsiveOnCallScheduleItem;
    const { width } = this.props;

    if (width !== "xs") {
      responsiveOnCallScheduleItem = 
        <div style={{ flexgrow: '1' }}>
          <Grid container spacing={0}>
            <Grid item xs={2}>
              <TextField
                defaultValue={this.state.beginTime}
                onChange={e => this.handleTimeChange('beginTime', e)} // time pickers don't have event.target.value
                id="time"
                type="time"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                defaultValue={this.state.endTime}
                onChange={e => this.handleTimeChange('endTime', e)}
                id="time"
                type="time"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                style={{ marginTop: '0px' }}
                id="primary"
                select
                value={this.state.prime}
                onChange={this.handleChange('prime')}
                margin="normal"
              >
                {salesMembers.map(option => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={2}>
              <TextField
                style={{ marginTop: '0px' }}
                id="alternate"
                select
                value={this.state.secondary}
                onChange={this.handleChange('secondary')}
                margin="normal"
              >
                {salesMembers.map(option => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={2}>
              <TextField
                style={{ marginTop: '0px' }}
                id="alternate2"
                select
                value={this.state.tertiary}
                onChange={this.handleChange('tertiary')}
                margin="normal"
              >
                {salesMembers.map(option => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={1}>
              <Button onClick={this.removeRow}>
                <i className="material-icons" fontSize="small" style={{ transform: 'scale(1.2)', fontSize: '14px', marginTop: '3px' }}>delete_outline</i>
              </Button>
            </Grid>
          </Grid>
        </div>;
    } else {
      responsiveOnCallScheduleItem = 
        <div>
          <Grid container spacing={0} style={{ paddingTop: '10px', paddingLeft: '10px', backgroundColor: '#ebebeb', marginTop: '5px' }}>
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <TextField
                  defaultValue={this.state.beginTime}
                  onChange={e => this.handleTimeChange('beginTime', e)} // time pickers don't have event.target.value
                  id="time"
                  type="time"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={1}>
                to
              </Grid>
              <Grid item xs={4}>
                <TextField
                  defaultValue={this.state.endTime}
                  onChange={e => this.handleTimeChange('endTime', e)}
                  id="time"
                  type="time"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={1}>
                <Tooltip
                  title={
                    <React.Fragment>
                      <h6>
                        Remove
                        </h6>
                    </React.Fragment>
                  }
                >
                  <IconButton onClick={this.removeRow} style={{ padding: '10px', marginLeft: '8px' }}>
                    <DeleteOutlineIcon style={{ color: 'black', fontSize: '15px' }} />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <TextField
                  style={{ marginTop: '0px'}}
                  id="primary"
                  select
                  value={this.state.prime}
                  onChange={this.handleChange('prime')}
                  margin="normal"
                >
                  {salesMembers.map(option => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  style={{ marginTop: '0px' }}
                  id="alternate"
                  select
                  value={this.state.secondary}
                  onChange={this.handleChange('secondary')}
                  margin="normal"
                >
                  {salesMembers.map(option => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  style={{ marginTop: '0px' }}
                  id="alternate2"
                  select
                  value={this.state.tertiary}
                  onChange={this.handleChange('tertiary')}
                  margin="normal"
                >
                  {salesMembers.map(option => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </Grid>
        </div>;
    }

    return (
      <div>
        {responsiveOnCallScheduleItem}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.members,
    memberIdMap: state.memberIdMap,
    memberNameMap: state.memberNameMap,
  };
}

//export default connect(mapStateToProps, null)(OnCallScheduleItem);

OnCallScheduleItem.propTypes = {
  width: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, null)(withWidth()(OnCallScheduleItem));


// WEBPACK FOOTER //
// ./src/components/OnCallScheduleItem.js